@if ($page(); as page) {
  @switch (page.template) {
    @case ('CategoryPageTemplate') {
      <ng-container [ngTemplateOutlet]="CategoryPageTemplate"> </ng-container>
    }
    @case ('TemplateSideBar') {
      <ng-container [ngTemplateOutlet]="CategoryPageTemplate"> </ng-container>
    }
    @case ('ErrorPageTemplate') {
      <ng-container [ngTemplateOutlet]="ErrorPageTemplate"> </ng-container>
    }
    @default {
      <ng-container [ngTemplateOutlet]="templateDefault"></ng-container>
    }
  }
}

<!-- -------------------------- TemplateDefault --------------------------- -->
<ng-template #templateDefault>
  <div class="spacing-container">
    <div class="category">
      <div class="top-slots">
        @if ($topSlots(); as topSlots) {
          @for (slot of topSlots; track $index) {
            <section
              [attr.position]="slot.position"
              [class]="slot.position"
              [class.page-fold]="slot === $pageFold()"
              [class.has-components]="slot.components?.component?.length"
              [boelsSlotDecorator]="slot.properties"
            >
              <ng-template #topSlotsRenderer></ng-template>
            </section>
          }
        }
      </div>
      <div class="middle-slots">
        @if ($pageSlots(); as pageSlots) {
          @for (slot of pageSlots; track $index) {
            <section
              [attr.position]="slot.position"
              [class]="slot.position"
              [class.page-fold]="slot === $pageFold()"
              [class.has-components]="slot.components?.component?.length"
              [boelsSlotDecorator]="slot.properties"
            >
              <ng-template #slotsRenderer></ng-template>
            </section>
          }
        }
      </div>
    </div>
  </div>
</ng-template>

<!-- -------------------------- CategoryPageTemplate ---------------------- -->
<ng-template #CategoryPageTemplate>
  <div class="spacing-container">
    <div class="category">
      <div class="top-slots">
        @if ($topSlots(); as topSlots) {
          @for (slot of topSlots; track $index) {
            <section
              [attr.position]="slot.position"
              [class]="slot.position"
              [class.page-fold]="slot === $pageFold()"
              [class.has-components]="slot.components?.component?.length"
              [boelsSlotDecorator]="slot.properties"
            >
              <ng-template #topSlotsRenderer></ng-template>
            </section>
          }
        }
      </div>
      <div class="middle-slots">
        @if ($pageSlots(); as pageSlots) {
          @for (slot of pageSlots; track $index) {
            <section
              [attr.position]="slot.position"
              [class]="slot.name"
              [class.page-fold]="slot === $pageFold()"
              [class.has-components]="slot.components?.component?.length"
              [boelsSlotDecorator]="slot.properties"
            >
              <ng-template #slotsRenderer></ng-template>
            </section>
          }
        }
      </div>
    </div>
  </div>
</ng-template>

<!-- -------------------------- ErrorPageTemplate ---------------------- -->
<ng-template #ErrorPageTemplate>
  <boels-page-not-found>
    @if ($pageSlots(); as pageSlots) {
      @for (slot of pageSlots; track $index) {
        <section
          [attr.position]="slot.position"
          [class]="slot.position"
          [class.page-fold]="slot === $pageFold()"
          [class.has-components]="slot.components?.component?.length"
          [boelsSlotDecorator]="slot.properties"
        >
          <ng-template #slotsRenderer></ng-template>
        </section>
      }
    }
  </boels-page-not-found>
</ng-template>
